require('./myWalletValuesModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const OKModal = require('components/commons/OKModal/OKModal');

// @components
const MyWalletImportsTable = require('./myWalletImportsTable');

// @constants
const { HYPHEN, ADDITION } = require('constants/index');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const { buildAbsoluteFormattedValue, formatWithoutRound, formatCurrency } = require('utilities/currencyHelper');

class MyWalletValuesModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleCloseHowWeCalculateModal = this.handleCloseHowWeCalculateModal.bind(this);
    }

    buildActualValueContent() {
        const {summarization, hasPendingOperations} = this.props;
        const actualValue = summarization.getIn(['total','valor']);
        const rightContentClass = actualValue
            ? 'broker-calculate-my-wallet-modal__right-content'
            : 'broker-calculate-my-wallet-modal__full-content';

        const actualValueRightContent = (
            <ContentBox hasShadow={false} customClassName={rightContentClass}>
                <FormattedText value="brokerCalculateMyWalletModal-firstHeaderText" />
            </ContentBox>
        );

        if (!actualValue) {
            return (
                <div> {actualValueRightContent} </div>
            );
        }
        else {
            const actualValueFormatted = buildAbsoluteFormattedValue(actualValue);
            let actualValueLeftContent;

            if (hasPendingOperations) {
                const rentabilityOperations = summarization.getIn(['consolidado','valor']);
                const pendingRentabilityOperations = summarization.getIn(['intradia','valor']);
                const rentabilityOperationsFormatted = buildAbsoluteFormattedValue(rentabilityOperations);
                const pendingRentabilityOperationsFormatted = !!pendingRentabilityOperations ? buildAbsoluteFormattedValue(pendingRentabilityOperations) : null;
                const leftContentClass = 'broker-calculate-my-wallet-modal__left-content';
                const symbol = !!pendingRentabilityOperations ? pendingRentabilityOperations.getIn(['importeEur','importe']) < 0 ? HYPHEN : ADDITION : null;
                const operationSymbol = (
                    <span className="broker-calculate-my-wallet-modal__operation-actual-value">
                        {symbol}
                    </span>
                );
                const rentabilityOperationsLabel = <FormattedText value="brokerCalculateMyWalletModal-rentabilityOperationsValue" />;
                const pendingRentabilityOperationsLabel = <FormattedText value="brokerCalculateMyWalletModal-pendingRentabilityOperationsValue" />;
                const actualValueLabel = <FormattedText value="myWallet-value" />;
                const secondValueClassName = 'broker-calculate-my-wallet-modal__three-lines-value';

                actualValueLeftContent = (
                    <MyWalletImportsTable
                        tableClassName={leftContentClass}
                        firstValue={rentabilityOperationsFormatted}
                        firstLabel={rentabilityOperationsLabel}
                        operationSymbol={operationSymbol}
                        secondValue={pendingRentabilityOperationsFormatted}
                        secondLabel={pendingRentabilityOperationsLabel}
                        secondValueClassName={secondValueClassName}
                        totalValue={actualValueFormatted}
                        totalLabel={actualValueLabel}
                    />
                );

            } else {
                actualValueLeftContent = (
                    <ContentBox hasShadow={false} customClassName="broker-calculate-my-wallet-modal__left-content">
                        <div className="broker-calculate-my-wallet-modal__first-table">
                            <span className="broker-calculate-my-wallet-modal__one-line-value">
                                {actualValueFormatted}
                            </span>
                            <FormattedText value="myWallet-value" />
                        </div>
                    </ContentBox>
                )
            }

            return (
                <div>
                    {actualValueLeftContent}
                    {actualValueRightContent}
                </div>
            );
        }
    }

    buildRentabilityContent() {
        const {summarization} = this.props;
        const totalRentability = summarization.getIn(['consolidado','rentabilidad']);
        const rightContentClass = totalRentability
            ? 'broker-calculate-my-wallet-modal__right-content'
            : 'broker-calculate-my-wallet-modal__full-content';

        const rentabilityRightContent = (
            <ContentBox hasShadow={false} customClassName={rightContentClass}>
                <FormattedText value="brokerCalculateMyWalletModal-secondHeaderText" />
            </ContentBox>
        );

        if (!totalRentability) {
            return (
                <div> {rentabilityRightContent} </div>
            );
        }
        else {
            const investmentCapital = summarization.getIn(['consolidado','capitalInvertido']);
            const rentabilityOperations = summarization.getIn(['consolidado','valor']);

            const rentabilityOperationsFormatted = buildAbsoluteFormattedValue(rentabilityOperations);
            const investmentCapitalFormatted = buildAbsoluteFormattedValue(investmentCapital);
            const profitability = formatWithoutRound(totalRentability.getIn(['importeEur', 'importe']), 2);
            const profitabilityCurrency = formatCurrency(totalRentability.getIn(['importeEur', 'moneda']));
            const totalRentabilityFormatted = `${profitability} ${profitabilityCurrency}`;

            const secondValueClassName = 'broker-calculate-my-wallet-modal__two-lines-value';
            const leftContentClass = 'broker-calculate-my-wallet-modal__left-content-rentability';
            const operationSymbol = (
                <span className="broker-calculate-my-wallet-modal__operation-rentability">
                    {HYPHEN}
                </span>
            );
            const rentabilityOperationsLabel = <FormattedText value="brokerCalculateMyWalletModal-rentabilityOperationsValue" />;
            const investmentCapitalLabel = <FormattedText value="brokerCalculateMyWalletModal-totalCapitalInvestment" />;
            const totalRentabilityLabel = <FormattedText value="broker-productEarnings" />;

            const rentabilityLeftContent = (
                <MyWalletImportsTable
                    tableClassName={leftContentClass}
                    firstValue={rentabilityOperationsFormatted}
                    firstLabel={rentabilityOperationsLabel}
                    operationSymbol={operationSymbol}
                    secondValue={investmentCapitalFormatted}
                    secondLabel={investmentCapitalLabel}
                    secondValueClassName={secondValueClassName}
                    totalValue={totalRentabilityFormatted}
                    totalLabel={totalRentabilityLabel}
                />
            );

            return (
                <div>
                    {rentabilityLeftContent}
                    {rentabilityRightContent}
                </div>
            );
        }
    }

    buildInvestmentCapitalContent() {
        return (
            <ContentBox hasShadow={false} customClassName="broker-calculate-my-wallet-modal__capital-investment">
                <FormattedText value="brokerCalculateMyWalletModal-thirdHeaderText" />
            </ContentBox>
        );
    }

    handleCloseHowWeCalculateModal() {
        this.props.onToggleModal();
    }

    render() {
        const actualValueContent = this.buildActualValueContent();
        const rentabilityContent = this.buildRentabilityContent();
        const investmentCapitalContent = this.buildInvestmentCapitalContent();
        const { isOpen } = this.props;

        const contentModal = (
            <div className="broker-calculate-my-wallet-modal__wrapper">
                <h4 className="broker-calculate-my-wallet-modal__header">
                    <FormattedText value="brokerCalculateMyWalletModal-firstHeader" />
                </h4>
                {actualValueContent}
                <h4 className="broker-calculate-my-wallet-modal__header">
                    <FormattedText value="brokerCalculateMyWalletModal-secondHeader" />
                </h4>
                {rentabilityContent}
                <h4 className="broker-calculate-my-wallet-modal__header">
                    <FormattedText value="brokerCalculateMyWalletModal-thirdHeader" />
                </h4>
                {investmentCapitalContent}
            </div>
        );

        return (
            <OKModal
                content={contentModal}
                size="large"
                isOpen={isOpen}
                footerType="navigation"
                onCloseCallback={this.handleCloseHowWeCalculateModal}
                onPrimaryButtonClick={this.handleCloseHowWeCalculateModal}
                primaryButtonText="brokerAttentionPlanStartingModal-understood"
            />
        );
    }
}

MyWalletValuesModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    hasPendingOperations: PropTypes.bool.isRequired,
    onToggleModal: PropTypes.func.isRequired,
    summarization: PropTypes.object.isRequired
};

module.exports = MyWalletValuesModal;
